module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalk.e8a65cf7.mp3";